import type { Permission } from '@hbac/contract';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/auth';
import { paths } from './paths';

/**
 * Client-side permission guard.
 *
 * Convenience, not security: every guarded endpoint is enforced server-side,
 * and a member who types /dashboard gets a 403 from the API regardless. This
 * just sends them somewhere useful instead of showing an error screen.
 */
export function RequirePermission({ permission, children }: { permission: Permission; children: React.ReactNode }) {
  const { can } = useAuth();
  if (!can(permission)) return <Navigate to={paths.portal} replace />;
  return <>{children}</>;
}

/** Current members only: alumni settle old bills but do not start new ones (the server refuses too). */
export function RequireMember({ children }: { children: React.ReactNode }) {
  const { isAlumni } = useAuth();
  if (isAlumni) return <Navigate to={paths.portal} replace />;
  return <>{children}</>;
}
